import { render, staticRenderFns } from "./PermissionsLeadsForm.vue?vue&type=template&id=0290f2e7&scoped=true&"
import script from "./PermissionsLeadsForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsLeadsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0290f2e7",
  null
  
)

export default component.exports